<div class="m-2">
    <mat-card>
        <mat-card-content>
            <div style="display: flex; gap: 8px;">
                <button mat-raised-button color="primary" (click)="createRequest()" [disabled]="isLoading">
                    Create request
                </button>
                <button mat-raised-button color="primary" (click)="refreshDocuments()" [disabled]="isLoading">
                    <mat-icon *ngIf="isLoading">refresh</mat-icon>
                    Refresh
                </button>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mt-4">
        <mat-card-content>
            <!-- State display component - handles loading, empty, and error -->
            <app-state-display
                *ngIf="showStateDisplay"
                [type]="stateType"
                loadingMessage="Loading Pandadoc documents..."
                emptyMessage="No files on Pandadoc"
                [errorMessage]="errorMessage || 'Failed to load documents'"
                emptyIcon="description"
                errorIcon="cloud_off">
            </app-state-display>

            <!-- Documents table -->
            <table class="p_table mt-4" *ngIf="showTable">
                <tr class="p_tr">
                    <th class="p_th">Document Name</th>
                    <th class="p_th">Status</th>
                    <th class="p_th">Created</th>
                    <th class="p_th">Modified</th>
                </tr>
                <tr *ngFor="let doc of pandadoc_documents" class="p_tr">
                    <td class="p_td">
                        <a target="_blank" href="https://app.pandadoc.com/a/#/documents/{{ doc.id }}">{{ doc.name }}</a>
                    </td>
                    <td class="p_td">{{ doc.status }}</td>
                    <td class="p_td">{{ doc.date_created | date : 'dd-MM-yyyy' }}</td>
                    <td class="p_td">{{ doc.date_modified | date : 'dd-MM-yyyy' }}</td>
                </tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>
